module.exports = __webpack_public_path__ + "img/banner.f5273c1e.png";